import { API } from '../../utils';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300, REQUEST, APPEALS, GIS, SIGNAL } = GW_SERVICES_PREFIXES;

/* Константы тикетов (Сообщений) */
export const GetSupportTicketsConstants = () =>
  API.get(`/${C300}/forms/support_tickets/constants/`);

export const GetTenantTicketsConstants = () =>
  API.get(`/${C300}/forms/tenant_tickets/constants/`);

/* Константы заявок */

export const GetRequestsConstants = () =>
  API.get(`/${REQUEST}/constants/request/`);

/* Константы квартир */
export const GetAreaConstants = () => API.get(`/${C300}/forms/area/constants/`);

/* Константы телефонии */
export const GetTelephonyConstants = () =>
  API.get(`/${C300}/call_log/constants/`);

/* Константы отчёта о просроченных счётчиках */
export const GetHistoryMetersConstants = () =>
  API.get(`/${C300}/history_meters/constants/`);

/* Константы автоматизации */
export const GetAutomationConstants = () =>
  API.get(`/${C300}/boilers/automation/constants/`);

/* Константы фильтров просроченных счётчиках */
export const GetOverdueMetersConstants = () =>
  API.get(`/${C300}/overdue_meters/constants/`);

/* Константы документооборота */
export const GetDocumentsConstants = () =>
  API.get(`/${C300}/forms/documents/constants/`);

/* Константы домов (тут есть sectors) */
export const GetHousesConstants = () =>
  API.get(`/${C300}/forms/house/constants/`);

/* Константы новостей */
export const GetNewsConstants = () => API.get(`/${C300}/news/constants/`);

/* Константы обращений */
export const GetAppealsConstants = () =>
  API.get(`/${APPEALS}/constants/appeal/`);

/* Константы ГИСа */
export const GetGISConstants = () => API.get(`/${GIS}/gis/constants/`);

/* Константы отчёта по исполнителям */
export const GetExecutorConstants = () =>
  API.get(`/${C300}/management_accounting/executor_constants/`);

/* Константы системы "Кристалл" */
export const GetCrystalConstants = () =>
  API.get(`/${SIGNAL}/kristalls/constants`);
